module.exports = __webpack_public_path__ + "static/media/students skills.3fdf7664.svg";